
import { defineComponent } from "vue";
import KTUserMenu from "@/layout/header/partials/UserMenu.vue";
import NameInitials from "@/components/question-note/NameInitials.vue";
import JwtService from "@/core/services/JwtService";

export default defineComponent({
  name: "header-topbar",
  components: {
    KTUserMenu,
    NameInitials,
  },
  setup() {
    const userName = JwtService.getUserName();

    return {
      userName,
    };
  },
});
